import React, { PureComponent } from 'react';
import { Person, VpnKey, GroupWork, SurroundSound } from '@material-ui/icons';
import axios from 'axios';
import ReactLoading from 'react-loading';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';

import { scaleOrdinal } from 'd3-scale';
import { schemeCategory10 } from 'd3-scale-chromatic';

// Material UI
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

// Local
import { BASE_URL } from 'consts';

const colors = scaleOrdinal(schemeCategory10).range();

// const data2 = [
//   {
//     day: 'Apr 01, 2019',
//     AD_DETECTED: 10,
//     LOCAL_LANDING_PAGE_HIT: 23,
//     AD_CLICKED: 1,
//     AD_DELETED: 23,
//   },
// ];

// const data = [
//   {
//     name: 'Page A',
//     uv: 4000,
//     pv: 2400,
//     amt: 2400,
//   },
//   {
//     name: 'Page B',
//     uv: 3000,
//     pv: 1398,
//     amt: 2210,
//   },
//   {
//     name: 'Page C',
//     uv: 2000,
//     pv: 9800,
//     amt: 2290,
//   },
//   {
//     name: 'Page D',
//     uv: 2780,
//     pv: 3908,
//     amt: 2000,
//   },
//   {
//     name: 'Page E',
//     uv: 1890,
//     pv: 4800,
//     amt: 2181,
//   },
//   {
//     name: 'Page F',
//     uv: 2390,
//     pv: 3800,
//     amt: 2500,
//   },
//   {
//     name: 'Page G',
//     uv: 3490,
//     pv: 4300,
//     amt: 2100,
//   },
// ];

export class Data2 extends PureComponent {
  state = {
    loadingEvents: true,
    loadingDeviceTypes: true,
    loadingAdDetectedFrequencies: true,
    loadingUUID: true,
    toneId: 166515,
    eventsByTone: [],
    deviceTypes: [],
    frequencies: [],
    totalQtyEvents: -1,
    totalUUID: -1,
    totalToneDetected: -1,
    totalSources: -1,
  };

  componentDidMount() {
    // Get events for the tone id
    this.getEventsByToneId().then(eventsByTone => {
      let total = 0;
      if (eventsByTone) {
        total = eventsByTone.reduce(this.sumQtyTotal, 0);
        this.setState({ totalQtyEvents: total });
      }
      if (eventsByTone && total !== 0) {
        // Get events frequencies
        this.getFrequencyByToneAndEventType(
          eventsByTone.map(el => el._id)
        ).then(freqs => {
          if (freqs) {
            const group = freqs.reduce((acc, cur) => {
              const found = acc.find(el => el.date_time === cur.date_time);
              if (!found) {
                acc.push({
                  date_time: cur.date_time,
                  [cur._id.eventType]: cur.qty,
                });
              } else {
                found[cur._id.eventType] = cur.qty;
              }
              return acc;
            }, []);

            group.sort((a, b) => {
              if (a.date_time < b.date_time) return -1;
              if (a.date_time > b.date_time) return 1;
              return 0;
            });
            this.setState({ frequencies: group });
          }
        });
      }
      if (eventsByTone) {
        this.setState({ eventsByTone, loadingEvents: false });
      }
    });
    this.getDeviceTypeByToneId();
    this.getToneDetectedByToneId();
    this.getSourcesByToneId();
    this.getUUIDByToneId();
  }

  pad(n) {
    return n < 10 ? '0' + n : n;
  }

  getSourcesByToneId = () => {
    var config = {
      headers: { token: 'B287F0D4-410D-4DB8-8F31-3656BA3A8526' },
    };
    axios
      .get(`${BASE_URL}/sourcesByToneId/${this.state.toneId}`, config)
      .then(({ data }) => {
        this.setState({ totalSources: data.length });
      })
      .catch(err => {
        console.log('error ', err);
      });
  };

  getToneDetectedByToneId = () => {
    var config = {
      headers: { token: 'B287F0D4-410D-4DB8-8F31-3656BA3A8526' },
    };
    axios
      .get(`${BASE_URL}/toneDetectedByToneId/${this.state.toneId}`, config)
      .then(({ data }) => {
        this.setState({ totalToneDetected: data.length });
      })
      .catch(err => {
        console.log('error ', err);
      });
  };

  getUUIDByToneId = () => {
    var config = {
      headers: { token: 'B287F0D4-410D-4DB8-8F31-3656BA3A8526' },
    };
    axios
      .get(`${BASE_URL}/uuidByToneId/${this.state.toneId}`, config)
      .then(({ data }) => {
        this.setState({ totalUUID: data.length });
      })
      .catch(err => {
        console.log('error ', err);
      });
  };

  getEventsByToneId = () => {
    var config = {
      headers: { token: 'B287F0D4-410D-4DB8-8F31-3656BA3A8526' },
    };
    return axios
      .get(`${BASE_URL}/eventsByToneId/${this.state.toneId}`, config)
      .then(({ data }) => data)
      .catch(er => {
        console.log('error ', er);
      });
  };

  getDeviceTypeByToneId = () => {
    var config = {
      headers: { token: 'B287F0D4-410D-4DB8-8F31-3656BA3A8526' },
    };
    axios
      .get(`${BASE_URL}/deviceByToneId/${this.state.toneId}`, config)
      .then(({ data }) => {
        this.setState({ deviceTypes: data, loadingDeviceTypes: false });
      });
  };

  getFrequencyByToneAndEventType = eventTypes => {
    var config = {
      headers: { token: 'B287F0D4-410D-4DB8-8F31-3656BA3A8526' },
    };
    return axios
      .get(
        `${BASE_URL}/frequencyByToneAndEventType/${
          this.state.toneId
        }/${eventTypes.join(',')}`,
        config
      )
      .then(({ data }) => {
        if (data) {
          const newData = data.map(el => {
            let year = el._id.year;
            let month = el._id.month;
            let day = el._id.day;
            const date_time =
              year + '-' + this.pad(month) + '-' + this.pad(day);
            //moment(el._id.date_time).format("YYYY-MM-DD");
            // moment(
            //   el.date_time,
            //   moment.HTML5_FMT.DATETIME_LOCAL_MS
            // ).format('MMM DD, YYYY');
            return { ...el, date_time };
          });
          return newData;
        }
        // const newData = data.map(el => {
        //   const date_time = moment(el._id.date_time).format("YYYY-MM-DD");
        //   // moment(
        //   //   el.date_time,
        //   //   moment.HTML5_FMT.DATETIME_LOCAL_MS
        //   // ).format('MMM DD, YYYY');
        //   return { ...el, date_time };
        // });
        // return newData;
      });
  };

  render() {
    return (
      <div className="shadow m-4 rounded p-4 bg-white">
        {this.renderCells()}
        {this.renderTable()}
        {this.renderFrequencyChart()}
      </div>
    );
  }

  renderFrequencyChart = () => {
    return (
      <div className="flex flex-grow flex-2 flex-col mt-2 p-1 bg-grey-lighter">
        <div className="text-blue text-base font-semibold pt-2 pl-2">
          Frequency
        </div>
        <div className="w-full h-64 pb-2 pt-2">
          <ResponsiveContainer>
            <BarChart
              data={this.state.frequencies}
              margin={{
                top: 20,
                right: 30,
                left: 20,
                bottom: 5,
              }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="date_time" />
              <YAxis interval={1} />
              <Tooltip />
              <Legend />
              {this.state.eventsByTone.map((freq, idx) => {
                return (
                  <Bar
                    key={freq._id}
                    dataKey={freq._id}
                    stackId="a"
                    fill={colors[idx % 20]}
                  />
                );
              })}
              {/* {this.state.loadingEvents.map(event => {
                console.log('event', event);
                return <Bar dataKey="AD_DETECTED" stackId="a" fill="#8884d8" />;
                // return <Bar dataKey="AD_DETECTED" stackId="a" fill="#8884d8" />;
              })} */}
              {/* <Bar dataKey="pv" stackId="a" fill="#8884d8" /> */}
              {/* <Bar dataKey="uv" stackId="a" fill="#82ca9d" /> */}
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    );
  };

  renderCells = () => {
    return (
      <div className="flex p-1 bg-grey-lighter">
        <div id="row1" className="flex flex-grow justify-between">
          {this.renderCel(
            this.state.totalQtyEvents,
            'Event Types',
            'bg-blue-light',
            <SurroundSound style={{ color: '#5993C2', fontSize: '3em' }} />
          )}
          {this.renderCel(
            this.state.totalSources,
            'Bundles',
            'bg-red-light',
            <GroupWork style={{ color: '#966C6B', fontSize: '3em' }} />
          )}
          {this.renderCel(
            this.state.totalToneDetected,
            'Tones Detected',
            'bg-green-light',
            <VpnKey style={{ color: '#49AB72', fontSize: '3em' }} />
          )}
          {this.renderCel(
            this.state.totalUUID,
            'Unique User Fingerprints',
            'bg-orange',
            <Person style={{ color: '#BE7630', fontSize: '3em' }} />
          )}
        </div>
      </div>
    );
  };

  renderTable = () => {
    return (
      <div className="flex">
        <div className="flex flex-grow flex-2 flex-col mt-2 p-1 bg-grey-lighter mr-1">
          <div className="text-blue text-base font-semibold pt-2 pl-2">
            Events
          </div>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Type</TableCell>
                <TableCell align="right">Count</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>{this.renderEventsRows()}</TableBody>
          </Table>
        </div>
        <div className="flex flex-grow  flex-1 flex-col mt-2 p-1 bg-grey-lighter ml-1">
          <div className="text-blue text-base font-semibold pt-2 pl-2">
            Devices
          </div>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Type</TableCell>
                <TableCell align="right">Count</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>{this.renderDevicesRows()}</TableBody>
          </Table>
        </div>
      </div>
    );
  };

  renderEventsRows = () => {
    return (
      <>
        {this.state.loadingEvents && (
          <tr className="ml-2">
            <td>
              <ReactLoading type="bubbles" color="#5993C2" />
            </td>
          </tr>
        )}
        {!this.state.loadingEvents &&
          this.state.eventsByTone.map(row => (
            <TableRow key={row._id}>
              <TableCell component="th" scope="row">
                {row._id}
              </TableCell>
              <TableCell align="right">{row.qty}</TableCell>
            </TableRow>
          ))}
      </>
    );
  };

  renderDevicesRows = () => {
    return (
      <>
        {this.state.loadingDeviceTypes && (
          <tr className="ml-2">
            <td>
              <ReactLoading type="bubbles" color="#5993C2" />
            </td>
          </tr>
        )}
        {!this.state.loadingDeviceTypes &&
          this.state.deviceTypes.map(row => (
            <TableRow key={row._id}>
              <TableCell component="th" scope="row">
                {row._id}
              </TableCell>
              <TableCell align="right">{row.qty}</TableCell>
            </TableRow>
          ))}
      </>
    );
  };

  renderCel = (value, label, bgcolor, icon) => {
    if (value === -1) {
      value = (
        <ReactLoading
          height={'20%'}
          width={'20%'}
          type="bubbles"
          color="white"
        />
      );
    }
    return (
      <div className={`flex ${bgcolor} flex-1 m-2 p-4`}>
        <div className="flex flex-col">
          <div className="text-white text-4xl font-bold">{value}</div>
          <div className="text-white text-1xl">{label}</div>
        </div>
        <div className="flex flex-grow justify-end items-center">{icon}</div>
      </div>
    );
  };

  sumQtyTotal = (acc, cur) => {
    return acc + cur.qty;
  };
}

export default Data2;
